/**
 * Preferência de movimento reduzido, lida E escutada (§15.6.1, M29). O signal muda durante a sessão, sem recarregar;
 * quem anima por JS (tween.ts, FlipList, mapa) assina o signal e pula para o estado final quando ele vira true.
 */
import { signal } from '@preact/signals';

const QUERY = '(prefers-reduced-motion: reduce)';

function initial(): boolean {
  return typeof matchMedia === 'function' && matchMedia(QUERY).matches;
}

export const reducedMotion = signal(initial());

let installed = false;

/** Instala o ouvinte de change uma única vez (idempotente). */
export function installReducedMotion(): void {
  if (installed || typeof matchMedia !== 'function') return;
  installed = true;
  const mq = matchMedia(QUERY);
  reducedMotion.value = mq.matches;
  mq.addEventListener('change', (e) => {
    reducedMotion.value = e.matches;
  });
}

/** Valor atual da preferência; re-renderiza o componente quando ela muda. */
export function useReducedMotion(): boolean {
  installReducedMotion();
  return reducedMotion.value;
}
